var existingProductIds=[];
var session=null;

class SDK {
    /**
      Authanticate login 
     * Refer : https://storefront.rechargepayments.com/client/docs/methods/api/auth/#loginshopifyappproxy--
    */

    async _authLogin(){
        session = await recharge.auth.loginShopifyAppProxy();
    }

    header() {
        return {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-Shop": window.customerDetails.url
        };
    }
    
    /**
      Get Customer details of the recharge 
     * @return  {JSON} - customer object
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/customer/#getcustomer---
    */

    async _getCustomerDetails() {
       
        await this._authLogin();
        try{
            const response= await recharge.customer.getCustomer(session);
            window.customerDetails.rechargeCustomerDetails=response;
            return window.customerDetails.rechargeCustomerDetails;
    
        }catch (error){
            // log the error message to the console
            this.notification('Something went wrong','Error in fetching customer details','error')
           // log the error message to the console
            Rollbar.error(`Error in fetching customer details: ${JSON.stringify(error)}`)
            return false;
        }
    }

    async _getCustomerPortal() {
        try{
            const response_customer = await recharge.customer.getCustomerPortalAccess(session);
            window.customerDetails.rechargeCustomerPortal=response_customer;
            return window.customerDetails.rechargeCustomerPortal;
    
        }catch (error){
            // log the error message to the console
            Rollbar.error(`Error in fetching customer portal: ${JSON.stringify(error)}`)
            this.notification('Something went wrong','Error in fetching customer details','error')
            return false;
        }
        return false;
    }


    /**
      Fetch All Subscriptions of logged in customer
     * @return  {JSON} - response.subscriptions
     * For more information : https://developer.rechargepayments.com/2021-11/subscriptions/subscriptions_list
    */
    async _getSubscriptions() {
        try{
            existingProductIds=[];
            const response= await recharge.subscription.listSubscriptions(session, {
                limit: 50,
                sort_by: 'id-asc',
            });
            window.customerDetails.rechargeSubscriptions=response.subscriptions;
            window.customerDetails.rechargeSubscriptions.sort((a, b) => {{
                if (a.next_charge_scheduled_at == null) return 1;
                if (b.next_charge_scheduled_at == null) return -1;
                return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
            }});
    
            existingProductIds=[...existingProductIds,...window.customerDetails.rechargeSubscriptions.map((sub)=>{return sub.external_product_id ? sub.external_product_id.ecommerce : sub.shopify_product_id })];

            return window.customerDetails.rechargeSubscriptions
        }catch(error){
            this.notification('Something went wrong','Error in fetching subscriptions','error')
            console.error('Error in fetching subscriptions ===>',error);
            Rollbar.error(`Error in fetching Subscription: ${JSON.stringify(error)}`);
        }
    }

    /**
      Create subscription product 
     * @param {JSON} - subsDataObj - need to pass shopify product id , address id, frequency, frequency unit, qty
     * @return  {JSON} - subcriptionn object
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#createsubscription---
    */
      async _createSubscriptionProduct(subsDataObj){
        try{
            const response = await recharge.subscription.createSubscription(session,subsDataObj);
            return response;
        }catch(error){
            this.notification('Something went wrong','Error in adding subscriptions','error')
            console.error('error in adding subscription product  ===>',error);
            Rollbar.error(`Error in adding subscription product: ${JSON.stringify(error)}`)
            return false;
        }
    }
    
    /**
      Fetch All Recharge Addresses of logged in customer
     * @param {Number|String} - customer_id - Recharge Id of the customer
     * @return  {JSON} - data.addresses
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/address/#listaddresses---
    */
    async _getCustomerAddresses() {
        try{
            const response= await recharge.address.listAddresses(session, {
                limit: 25,
                sort_by: 'id-asc',
            });
            window.customerDetails.rechargeCustomerAddress=response.addresses;
            return window.customerDetails.rechargeCustomerAddress;
    
        }catch(error){
            this.notification('Something went wrong','Error in fetching Addresses','error')
            console.error('Error in fetching Addresses ===>',error);
            Rollbar.error(`Error in fetching Address: ${JSON.stringify(error)}`)
        }
    }

    /**
      Fetch All Registered payment methods of logged in customer
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/payment_method/#listpaymentmethods---
    */
   
    async _getPaymentMethods() {
        try{
            const response = await recharge.paymentMethod.listPaymentMethods(session, {
                limit: 25,
            });
            window.customerDetails.rechargePaymentMethods=response.payment_methods;
            return window.customerDetails.rechargePaymentMethods;
        }catch(error){
            this.notification('Something went wrong','Error in fetching PaymentMethods','error')
            console.error('Error in fetching PaymentMethods ===>',error);
            Rollbar.error(`Error in fetching Payment Methods: ${JSON.stringify(error)}`)
        }
    }

    /**
      Fetch All Onetime Addons of logged in customer
     * @return  {JSON} - response.onetimes
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/onetime/#listonetimes---
    */

    async _getOnetimes() {
        try{
            const response= await recharge.onetime.listOnetimes(session, {
                limit: 25,
                sort_by: 'id-asc',
            });
            window.customerDetails.rechargeOnetimes=response.onetimes;
            existingProductIds=[...existingProductIds,...window.customerDetails.rechargeOnetimes.map((sub)=>{return sub.external_product_id ? sub.external_product_id.ecommerce : sub.shopify_product_id })]
    
            return window.customerDetails.rechargeOnetimes;
        }catch(error){
            this.notification('Something went wrong','Error in fetching onetimes','error')
            console.error('Error in fetching onetimes ===>',error);
            Rollbar.error(`Error in fetching onetimes: ${JSON.stringify(error)}`)
        }
    }

    /**
      Fetch Shopify Product variants price and images by GRAPHQL call     
     * @param {String} - ids - Recharge Id of the customer (Example : {'ids' : '632910392,63291234,63212347'}  )  
     * @return  {JSON} - data.products
    */

      async _getProductsJsonByGraphQl() {
        let tempGraphQLjson={};
        try{
           
            const response = await recharge.product.productSearch(session, {
                limit: 250,
                format_version: '2022-06',
                external_product_ids :existingProductIds,
                product_published_status : 'any'
              });
         
              let product_json = response.products;
              for (let id of existingProductIds) {
                    let ProductData = product_json.find(x=> x.external_product_id == id);
                  
                    if(ProductData != undefined ){
                        
                        let pid=ProductData.external_product_id;
                        let handle=ProductData.handle;
                        let images = ProductData.images[0].medium;
                        let obj= {
                            pid,
                            handle,
                            images,
                            variants:{}
                        };  
                        obj['variants']=ProductData.variants;
                        tempGraphQLjson[id]=obj;
                    }
                    
                }

            // console.log(tempGraphQLjson,"tempGraphQLjson");
            window.customerDetails.graphQLProductsJSON=tempGraphQLjson;
            return await tempGraphQLjson;
              
        }catch(err){
            console.log(err)
            Rollbar.error(`Error in _getProductsJsonByGraphQl() function: ${err.toString()} , Customer: ${customerDetails.email}`);
        }
        
    }

    // async _getProductsJsonByGraphQl() {
    //     console.log(existingProductIds,"existingProductIds")
    //     let tempGraphQLjson={};
    //     try{
    //         let product_json = window.productJsonData;
    //         console.log(product_json,'product_json')
    //         for (let id of existingProductIds) {
                
    //             let ProductData = product_json.find(x=> x.id == id);
    //             if(ProductData != undefined ){
                    
    //                 let pid=ProductData.id;
    //                 let handle=ProductData.handle;
    //                 let images = ProductData.images;
    //                 let obj= {
    //                     pid,
    //                     handle,
    //                     images,
    //                     variants:{}
    //                 };  
    //                 obj['variants']=ProductData.variants;
    //                 tempGraphQLjson[id]=obj;
    //             }
                
    //         }
    //     }catch(err){
    //         console.log(err)
    //         Rollbar.error(`Error in _getProductsJsonByGraphQl() function: ${err.toString()} , Customer: ${customerDetails.email}`);
    //     }
    //     window.customerDetails.graphQLProductsJSON=tempGraphQLjson;
    //     return await tempGraphQLjson;
    // }
    
    /**
      Fetch Upcoming Charges 
     * @param {String} - status - possible values : queued , success , refunded , partially_refunded
     * @return  {JSON} - response.charges
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/charge/#listcharges---
    */
    async _getUpcomingCharges(){
        try{
            let config={
                status: 'queued',
                limit: 100,
                sort_by: 'id-asc',
            }
            const response = await recharge.charge.listCharges(session, config);
            return response.charges;
        }catch(error){
            this.notification('Something went wrong','Error in fetching upcoming queued charges','error')
            console.error('error in fetching upcoming charges ===>',error);
            //Rollbar.error(`Error in fetching upcoming Charges: ${JSON.stringify(error)}`)
        }
    }
    
    /**
      Fetch Delivery Schedule
     * @param {String} - future_interval - default: 90, max=365
     * @return  {JSON} - response.deliveries
     *   For more information : https://storefront.rechargepayments.com/client/docs/methods/api/customer/#getdeliveryschedule---
    */
    async _getDeliverySchedule(){
        try{
            let config={
                status: 'queued',
                limit: 100,
                sort_by: 'id-asc',
                delivery_count_future:150,
                purchase_item_id: subscriptionData.id,
            }
            const response = await recharge.customer.getDeliverySchedule(session, config);
            window.customerDetails.rechargeDeliverySchedule=response
            return window.customerDetails.rechargeDeliverySchedule;
        }catch(error){
            this.notification('Something went wrong','Error in fetching upcoming deliveries','error')
            console.error('error in fetching upcoming charges ===>',error);
            Rollbar.error(`Error in get delivery schedule: ${JSON.stringify(error)}`);
        }
    }


    async _getUpcomingOrders(){
        try{
            let config={
                status: 'queued',
                purchase_item_id: subscriptionData.id,
                limit : 100,
                sort_by: 'id-asc',
            }
            const response = await recharge.order.listOrders(session, config);
            return response.orders;
        }catch(error){ 
            this.notification('Something went wrong','Error in fetching upcoming deliveries','error')
            console.error('error in fetching upcoming charges ===>',error);
            Rollbar.error(`Error in get Upcoming order: ${JSON.stringify(error)}`);
        }
    }

    /**
      Change Charge Date
     * @param {number} - subscription_id 
     * @param {Date} - next_charge_date {Format : 'YYYY-MM-DD'} - (Date must be future date)
     * @return  {JSON} - subscription object
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#updatesubscription---
    */
    async _changeChargeDate(subscription_id,next_charge_date){
        try{
            var newProperties = {};
            var isPauseExist = false;
            if (subscriptionData.properties.length > 0) {
                subscriptionData.properties.forEach(prop => {
                    if (prop.name == "isPause" && prop.value == 'true') {
                        prop.value = 'false'
                        isPauseExist = true;
                    }else if(prop.name == "isPause" && prop.value == 'false') {
                        prop.value = 'true'
                        isPauseExist = true;
                    }
                });
            }
            if (isPauseExist == false) {
                subscriptionData.properties.push({ name: 'isPause', value: 'true' })
            }

            var updatedSubsObj = {
                next_charge_scheduled_at: next_charge_date,
                properties: subscriptionData.properties
            };
            

            const response = await this._updateSubscription(subscription_id, updatedSubsObj)
            if (response) {
                return await true;
            }
        }catch(error){
            this.notification('Something went wrong','Error in updating charge date','error')
            console.error('error in updating charge date ===>',error)
            Rollbar.error(`Error in Change charge date: ${JSON.stringify(error)}`);
            return await false;
        }
    }


    /**
      Update One-time Addon 
     * @param {Number|String} - addonsList - Addon Id and each id seperated by comma
     * @param {JSON} - addonObj - can be change charge date / Address Id / Price / Quantity
     * @return  {JSON} - subscription object
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/onetime/#updateonetime---
    */
      async _changeChargeDateAddon(addonsList,newChargeDate){
        let promises = [];
        for (let addon of addonsList) {
            var addonObj={
                'commit_update': true,
                'next_charge_scheduled_at': newChargeDate
            }
            promises.push(await recharge.onetime.updateOnetime(session, addon.id, addonObj));
        }
        try{
            const response = await Promise.all(promises);
        }catch(error){
            this.notification('Something went wrong','Error in updating addon','error')
            console.error('error in updating addpon ===>',error);
            Rollbar.error(`Error in change charge date addon: ${JSON.stringify(error)}`);
        }
    }

    /**
      Cancel Subscriptions
     * @param {Number|String} - subscription_id
     * @param {String} - cancellation_reason
     * @param {String} - cancellation_reason_comments 
     * @return  {JSON} - subscription object
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#cancelsubscription---
    */
    async _cancelSubscription(subscription_id,reason,feedback){
        try{
            let config={
                cancellation_reason: reason,
                cancellation_reason_comments: feedback
            }
            const response = await recharge.subscription.cancelSubscription(session, subscription_id, config);
            return await true;
        }catch(error){
            this.notification('Something went wrong','Error in cancelling subscription','error')
            console.error('error in cancelling subscription ===>',error);
            Rollbar.error(`Error in cancelling subscription: ${JSON.stringify(error)}`);
        }
    }

    /**
      Reactivate Subscriptions
     * @param {Number|String} - subscription_id
     * @return  {JSON} - data
     
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#activatesubscription---
    */

    async _reActivateSubscription(subscription_id){
        try{
            await recharge.subscription.activateSubscription(session, subscription_id);
            return await true;
        }catch(error){
            this.notification('Something went wrong','Error in Reactivating subscription','error')
            console.error('error in Reactivating subscription ===>',error);
            Rollbar.error(`Error in Reactivating subscription: ${JSON.stringify(error)}`);
        }
    }

    /**
      Change Shipping Address
     * @param {Number|String} - addressId 
     * @param {Number|String} - updatedAddressObj - can be change shipping address / Shipping charge / Apply discount / remove discount
      Take reference from : https://storefront.rechargepayments.com/client/docs/methods/api/address/#updateaddress---

     * @return  {JSON} - data
    */
    async _changeShippingAddress(addressId,updatedAddressObj){
        try {
            const response=await recharge.address.updateAddress(session, addressId, updatedAddressObj);
            return await true;
        } catch (error) {
            document.querySelector("[data-update_shipping_address]").classList.remove("disabled")
            if (error.status == 422) {
                this.notification('Enter Valid Address',JSON.parse(error.message).province??JSON.parse(error.message).zip??JSON.parse(error.message).all??'Invalid Address','error')
                console.error('error in updating address ===>',error);
                Rollbar.error(`Error in updating address: ${JSON.stringify(error)}`);
            }else{
                this.notification('Something went wrong','Error in Updating address','error')
                console.error('error in updating address ===>',error);
                Rollbar.error(`Error in updating address: ${JSON.stringify(error)}`);
            }
            return await false;
        }
    }

    /**
      Update Subscription

     * @param {Number|String} - subscription_id 
     * @param {Number|String} - updateSubscriptionObj - can be change Subscription price / Shipping Frequency / Product / variant

      Take reference from : https://storefront.rechargepayments.com/client/docs/methods/api/subscription/#updatesubscription---

     * @return  {JSON} - subscription object
      
     *Note*: For changing Subscription Frequency , must need to pass these three parameters : https://d.pr/i/y32aVI 
    */
    async _updateSubscription(subscription_id,updateSubscriptionObj){
      
        try{
            const response=await recharge.subscription.updateSubscription(session, subscription_id, updateSubscriptionObj);
            return await true;
        }catch(error){
            this.notification('Something went wrong','Error in Updating subscription','error')
            console.error('error in updating subscription ===>',data);
            Rollbar.error(`Error in updating subscription: ${JSON.stringify(error)}`);
            return await false;
        }
    }

    /**
      Add One-time Addon

     * @param {JSON} - addonObj - need to pass shopify product id , shopify variant id and address id
     
     *Note* : Add to next charge : https://d.pr/i/tRC129 => if you set the true , then addon date should be added with first upcoming charge date in specified address id
            if you want to set manual charge date then you need to pass : https://d.pr/i/m2vYID , but you can use both these param
     
     * @return  {JSON} - data
    
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/onetime/#createonetime---
    */
    async _createOnetimeAddon(addonObj){
        try{
            await recharge.onetime.createOnetime(session,addonObj);
            return await true;
            
        }catch(error){
            this.notification('Something went wrong','Error in Adding onetime Addon','error')
            console.error('error in adding onetime Addon ===>',error)
            Rollbar.error(`Error in adding onetime addon: ${JSON.stringify(error)}`);
            return false;
        }
    }


    /**
      Update One-time Addon 

     * @param {Number|String} - addon_id - Addon Id

     * @param {JSON} - addonObj - can be change charge date / Address Id / Price / Quantity
     
     * @return  {JSON} - data
    
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/onetime/#updateonetime---
    */
    async _updateOnetimeAddon(addon_id,addonObj){
        try{
            await recharge.onetime.updateOnetime(session, addon_id, addonObj);
            return true;
        }catch(error){
            this.notification('Something went wrong','Error in Updating onetime Addon','error')
            console.error('error in updating onetime Addon ===>',data);
            Rollbar.error(`Error in updating onetime addon: ${JSON.stringify(error)}`);
        }
    }

    /**
      Remove One-time Addon 

     * @param {Number|String} - addon_id - Addon Id
     
    
     * For more information : https://storefront.rechargepayments.com/client/docs/methods/api/onetime/#deleteonetime---
    */
    async _removeOnetimeAddon(addon_id){
        try{
            await recharge.onetime.deleteOnetime(session, addon_id);
            return await true;
        }catch(error){
            this.notification('Something went wrong','Error in Removing onetime Addon','error')
            console.error('error in Removing Addon ===>',error);
            Rollbar.error(`Error in removing addon: ${JSON.stringify(error)}`);
            return await false;
        }
    }

    /**
      Remove One-time Addon 

     * @param {JSON} - addonsList - Addon ID Object to delete addons
     
    
     * For more information : hhttps://storefront.rechargepayments.com/client/docs/methods/api/onetime/#deleteonetime---
    */
      async _removeOnetimeAddons(addonsList){

        let promises = [];
        for (let addon of addonsList) {
            const response = await fetch(await recharge.onetime.deleteOnetime(session, addon.id));
            promises.push(response);
        };
        try{
            const response = await Promise.all(promises);
            return await true;
        }catch(error){
            this.notification('Something went wrong','Error in deleting addon','error')
            console.error('error in deleting addon ===>',error);
            Rollbar.error(`Error in deleting addon: ${JSON.stringify(error)}`);
            return await false;
        }
    }

     /**
    * Apply Discount Based on charge id
    * 
    * @param {Number} charge_id
    * @param {Number} discount_id
    */
     async applyDiscountToAddress(addressId,promocode){
        try {
            const response = await recharge.address.applyDiscountToAddress(session, addressId, promocode);
            return await true;
        } catch (error) {
            // Rollbar.error(`Recharge => Error in promocode : ${promocode}`);
            this.notification('Something went wrong',JSON.parse(error.message)?.discount??'Invalid Promocode','error')
            console.error('error in updating address ===>',error);
            Rollbar.error(`Error in apply discount to address: ${JSON.stringify(error)}`);
            return await false;
        }
    }

    notification(title,body,notficationType){
        window.notificationEle.updateNotification(title, body, {
          type: notficationType, // success, warning, info, error
          timeout: 3000 // after how many seconds the notification should disappear
        });
      }

    async getCancelReason(){
        try{
            const response = await fetch(`/tools/platecrate-custom-api/retention-strategies`,{
                method: 'POST',
            }).then(function(response){
                return response.json();
            }).then(function(response){
                return response
            })
           return response;   
        }catch(error){
            let default_response = {
                "retention_strategies": [
                  {
                    "incentive_type": null,
                    "prevention_text": "Please help us process your request by telling us why you're cancelling.",
                    "reason": "Other reason"
                  },
                  {
                    "incentive_type": "swap_product",
                    "prevention_text": "Would you like to swap the product out for another item?",
                    "reason": "I want a different product or variety"
                  },
                  {
                    "incentive_type": null,
                    "prevention_text": "Please help us process your request by telling us why you're cancelling.",
                    "reason": "I no longer use this product"
                  },
                  {
                    "incentive_type": null,
                    "prevention_text": "Please help us process your request by telling us why you're cancelling.",
                    "reason": "I need it sooner"
                  },
                  {
                    "incentive_type": "delay_subscription",
                    "prevention_text": "If you have more than you need, we can skip your upcoming order.",
                    "reason": "I already have more than I need"
                  },
                  {
                    "incentive_type": null,
                    "prevention_text": "Would you care to provide any additional details?",
                    "reason": "This was created by accident"
                  },
                  {
                    "incentive_type": "delay_subscription",
                    "prevention_text": "Please help us process your request by telling us why you're cancelling.",
                    "reason": "This is too expensive"
                  }
                ]
              }
            return default_response
        }
    }
    
   
    async _update_shirt(data){
        try{
            const response = await fetch(`/tools/platecrate-custom-api/update-subscription`,{
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data),
            });
            return await true;
        }catch{
            Utility.notification('Something went wrong','Error in Updating subscription','error')
            console.error('error in updating subscription ===>',error);
            Rollbar.error(`Error in update Shirt size: ${JSON.stringify(error)}`);
            return await false;
        }
    }
    async update_incomingOrder(data){
        let orders = {"orders": data};
        try{
            const response = await fetch(`/tools/platecrate-custom-api/update-queued-orders-line-items`,{
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(orders),
            });
            return await true;
        }catch{
            Utility.notification('Something went wrong','Error in Updating upcoming subscription','error')
            console.error('error in updating upcoming subscription ===>',error);
            Rollbar.error(`Error in update incoming order: ${JSON.stringify(error)}`);
            return await false;
        }
    }
}

var sdk = new SDK();
